import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Modal } from 'antd';

const VERSION_POPUP_ENABLED =
  import.meta.env.VITE_ENABLE_VERSION_POPUP === 'true';
const CURRENT_ENV = import.meta.env.VITE_ENV || '-';
const REQUIRED_CLICK_COUNT = 3;
const CONTINUOUS_CLICK_INTERVAL = 1200;

const VersionInfoPopup = forwardRef(function VersionInfoPopup(_, ref) {
  const clickTimesRef = useRef([]);

  // 请求版本文件，并展示当前环境和版本信息
  const openVersionInfoPopup = async () => {
    let currentVersion = '-';

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    try {
      const response = await fetch(`/version.json?t=${Date.now()}`, {
        cache: 'no-store',
      });

      if (response.ok) {
        const data = await response.json();
        currentVersion = data?.version || currentVersion;
      }
    } catch (error) {
      console.warn('版本信息获取失败', error);
    }

    Modal.info({
      title: '版本信息',
      content: (
        <div>
          <p>当前环境：{CURRENT_ENV}</p>
          <p>当前版本：{currentVersion}</p>
        </div>
      ),
      okText: '知道了',
      focusTriggerAfterClose: false,
    });
  };

  // 处理用户图标连续点击，达到三次后打开版本信息弹窗
  const handleTriggerClick = () => {
    if (!VERSION_POPUP_ENABLED) {
      return;
    }

    const now = Date.now();
    clickTimesRef.current = [...clickTimesRef.current, now].filter(
      (time) => now - time <= CONTINUOUS_CLICK_INTERVAL
    );

    if (clickTimesRef.current.length >= REQUIRED_CLICK_COUNT) {
      clickTimesRef.current = [];
      openVersionInfoPopup();
    }
  };

  useImperativeHandle(ref, () => ({
    handleTriggerClick,
  }));

  return null;
});

export default VersionInfoPopup;
